// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"9b7c6906","904":"eaf2d983"}[chunkId] + ".chunk.js";
};